import request from '@/utils/request'
// 获取课程数据
export function getCourseData(data) {
  return request({
    url: 'stats/platform/course',
    method: 'POST',
    data,
  })
}
// 获取学期统计
export function getSemesterData(data) {
  return request({
    url: 'stats/platform/semester',
    method: 'POST',
    data,
  })
}
// 获取实时在线数据
export function getOnlineData(data) {
  let { responseType, ...restData } = data;
  return request({
    url: "stats/platform/onlineData",
    method: "POST",
    data: restData,
    responseType: responseType || "",
  });
}
// 获取实时在线课程列表
export function getOnlineCourseDetail(data) {
  let { responseType, ...restData } = data;
  return request({
    url: "stats/platform/onlineCourseDetail",
    method: "POST",
    data: restData,
    responseType: responseType || "",
  });
}
// 获取实时在线用户列表
export function getOnlineUserDetail(data) {
  let { responseType, ...restData } = data;
  return request({
    url: "stats/platform/onlineUserDetail",
    method: "POST",
    data: restData,
    responseType: responseType || "",
  });
}
// 获取无效课程数据
export function getInvalidCourse(data) {
  let { responseType, ...restData } = data
  return request({
    url: 'stats/platform/invalid',
    method: 'POST',
    data: restData,
    responseType: responseType || '',
  })
}
// 获取访问分析数据
export function getAccessAnalyse(data) {
  return request({
    url: 'stats/platform/access',
    method: 'POST',
    data,
  })
}
// 中大-搜索获取访问分析数据
export function getSearchAccessAnalyse(data) {
  return request({
    url: 'stats/platform/accessSearch',
    method: 'POST',
    data,
  })
}
